<div class="cc-card">
	<div class="card-inner">
		<div class="front">
			<div class="row">
				<img src="assets/images/master_card_logo.png" width="60px" style="width: 60px;">
				<img src="assets/images/visa_logo.png" width="60px" style="width: 60px;">
			</div>
			<div class="row">
				<div class="col-12 card-no" align="left">
					<span class="card-numbers">{{cardNumber.one}}</span>
					<span class="card-numbers">{{cardNumber.two}}</span>
					<span class="card-numbers">{{cardNumber.tree}}</span>
					<span class="card-numbers">{{cardNumber.four}}</span>
					<span class="card-numbers" *ngIf="cardNumber.five !== '****' ">{{cardNumber.five}}</span>
				</div>

			</div>
			<div class="row card-holder">
				<div class="col-8" align="left">
					<p>CARD HOLDER</p>
				</div>
				<div class="col-4" align="right">
					<p>VALID TILL</p>
				</div>

			</div>
			<div class="row name">
				<div class="col-8" align="left">
					<p>{{name.first | uppercase }} {{name.last | uppercase }}</p>
				</div>
				<div class="col-4" align="right">
					<p>{{expDate.month}} / {{expDate.year}}</p>
				</div>
			</div>
		</div>
		<div class="back">
			<img src="https://i.ibb.co/PYss3yv/map.png" class="map-img">
			<div class="bar"></div>
			<div class="row card-cvv">
				<div>
					<img src="https://i.ibb.co/S6JG8px/pattern.png">
				</div>
				<p>824</p>
			</div>
			<div class="row card-text">
				<p>this is a virtual card design using HTML and CSS. You can aslo design something like this.</p>
			</div>
			<div class="row signature">
				<p>CUSTOMER SIGNATURE</p>
				<img src="https://i.ibb.co/WHZ3nRJ/visa.png" width="80px">
			</div>
		</div>
	</div>
</div>
